/** The pills that fit on one row: unselected ones drop off from the end, selected ones always stay. */
export const fitPills = (
  pills: string[],
  widthOf: (pill: string) => number,
  selected: string[],
  available: number,
  gap: number,
): string[] => {
  const shown = [...pills];
  const width = (): number => shown.reduce((sum, pill) => sum + widthOf(pill), 0) + gap * Math.max(0, shown.length - 1);

  for (let index = shown.length - 1; index >= 0 && width() > available; index -= 1) {
    if (!selected.includes(shown[index])) shown.splice(index, 1);
  }

  return shown;
};
